module.exports = __webpack_public_path__ + "static/media/Mapa-Rondônia.ec9fceba.svg";